var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeatLayout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49607 1.49902H1.99772C1.72176 1.49902 1.49805 1.72273 1.49805 1.99869V4.49705C1.49805 4.77301 1.72176 4.99672 1.99772 4.99672H4.49607C4.77203 4.99672 4.99574 4.77301 4.99574 4.49705V1.99869C4.99574 1.72273 4.77203 1.49902 4.49607 1.49902Z",
    stroke: "#99A1AF",
    strokeWidth: 0.999342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99412 1.49902H7.49576C7.2198 1.49902 6.99609 1.72273 6.99609 1.99869V4.49705C6.99609 4.77301 7.2198 4.99672 7.49576 4.99672H9.99412C10.2701 4.99672 10.4938 4.77301 10.4938 4.49705V1.99869C10.4938 1.72273 10.2701 1.49902 9.99412 1.49902Z",
    stroke: "#99A1AF",
    strokeWidth: 0.999342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99412 6.99536H7.49576C7.2198 6.99536 6.99609 7.21907 6.99609 7.49503V9.99339C6.99609 10.2693 7.2198 10.4931 7.49576 10.4931H9.99412C10.2701 10.4931 10.4938 10.2693 10.4938 9.99339V7.49503C10.4938 7.21907 10.2701 6.99536 9.99412 6.99536Z",
    stroke: "#99A1AF",
    strokeWidth: 0.999342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49607 6.99536H1.99772C1.72176 6.99536 1.49805 7.21907 1.49805 7.49503V9.99339C1.49805 10.2693 1.72176 10.4931 1.99772 10.4931H4.49607C4.77203 10.4931 4.99574 10.2693 4.99574 9.99339V7.49503C4.99574 7.21907 4.77203 6.99536 4.49607 6.99536Z",
    stroke: "#99A1AF",
    strokeWidth: 0.999342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatLayout);
export default __webpack_public_path__ + "static/media/seat_layout.fc345ee3387308295458502b5d900162.svg";
export { ForwardRef as ReactComponent };